import { render } from "./SurveyTopBar.vue?vue&type=template&id=281a6244&scoped=true"
import script from "./SurveyTopBar.vue?vue&type=script&lang=js"
export * from "./SurveyTopBar.vue?vue&type=script&lang=js"

import "./SurveyTopBar.vue?vue&type=style&index=0&id=281a6244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281a6244"]])

export default __exports__